import { abbreviateNumber } from './helpers'

export const serializeGroupData = (groups = []) => {
  return groups.map((group) => {
    return {
      ...group,
      groups_users_count: abbreviateNumber(group.groups_users_count),
      posts_count: abbreviateNumber(group.posts_count),
      views_count: abbreviateNumber(group.posts_count),
    }
  })
}
